// extracted by mini-css-extract-plugin
module.exports = {"modal":"DownloadSyllabus_modal__TF_qj","image":"DownloadSyllabus_image__OJ33A","button":"DownloadSyllabus_button__8A6tl"};